import { memo } from 'react';
import classNames from 'classnames';
import styles from './ErrorMessage.module.scss';

export type Props = {
  errors?: string;
  className?: string;
  dataTest?: string;
};

function ErrorMessage({ errors, className, dataTest = 'errorMessage' }: Props) {
  if (!errors || errors === 'undefined') {
    return null;
  }

  const list = errors.split('-divider-');
  const moreThanOneError = list ? list?.length > 1 : false;

  return (
    <div className={className} data-test={dataTest}>
      {list.length > 1 ? (
        <ul
          className={classNames(
            styles['error-list'],
            moreThanOneError && styles.points,
          )}
        >
          {list.map(
            (item, index) =>
              item && (
                <li key={item} data-test={`${dataTest}-item-${index}`}>
                  {item}
                </li>
              ),
          )}
        </ul>
      ) : (
        <span
          className={styles['error-message']}
          dangerouslySetInnerHTML={{ __html: list[0] }}
        />
      )}
    </div>
  );
}

const ErrorMessageMemo = memo(ErrorMessage);

export default ErrorMessageMemo;
